// extracted by mini-css-extract-plugin
export default {"container":"BannerWithSocialIcons_container__67GSw"};